import { render, staticRenderFns } from "./UploadBallots.vue?vue&type=template&id=438b64de&"
import script from "./UploadBallots.vue?vue&type=script&lang=js&"
export * from "./UploadBallots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports